import {
  SignUpMessages,
  TranslationSignUpMessages
} from "../interfaces/signUpMessages";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationSignUpMessages = {
  [SignUpMessages.signUpTitlePage]: "New user",
  [SignUpMessages.signUpEmailLabel]: "Email",
  [SignUpMessages.signUpFullNameLabel]: "Full name",
  [SignUpMessages.signUpDocumentLabel]: "Document",
  [SignUpMessages.signUpRoleLabel]: "Role",
  [SignUpMessages.signUpPhoneNumberLabel]: "Phone Number",
  [SignUpMessages.signUpClientName]: "Client Name",
  [SignUpMessages.signUpClientNameLabel]: "Client Name (Same as in the contract)",
  [SignUpMessages.signUpPasswordLabel]: "Password",
  [SignUpMessages.signUpPasswordConfirmationLabel]: "Password confirmation",
  [SignUpMessages.signUpButton]: "SignUp",
  [SignUpMessages.signUpInvalidEmail]: "Invalid email",
  [SignUpMessages.signUpRequiredEmail]: "Email is required",
  [SignUpMessages.signUpFullNameRequired]: "Full name is required",
  [SignUpMessages.signUpPasswordRequired]: "Password is required",
  [SignUpMessages.signUpPasswordConfirmationRequired]:
    "Password confirmation is required",
  [SignUpMessages.signUpPasswordConfirmationMatch]: "Passwords do not match",
  [SignUpMessages.signUpFailed]:
    "Failed to signUp, check your data and try again"
};
